module.exports = __webpack_public_path__ + "static/media/noe-lamp-img1.e6d87426.jpg";